import { memo, useCallback, useMemo } from 'react'

import { AppId } from '@inno-tools/container-bridge'
import { useAvailableApps } from 'modules/app-registry/hooks/useAvailableApps'
import { useMountApp } from 'modules/app-registry/hooks/useMountApp'
import { useNavigate } from 'react-router-dom'
import { useUserContext } from 'shared/hooks/useUserContext'

export const LiveChatScreenRecorder = memo(() => {
  const { user } = useUserContext()
  const navigate = useNavigate()
  const { apps } = useAvailableApps()

  const goToLiveChat = useCallback(() => {
    navigate(apps[AppId.LIVE_CHAT].path, { replace: true })
  }, [navigate, apps])

  const appProps = useMemo(() => ({ goToLiveChat }), [goToLiveChat])

  const { ref, isLoaded, isError } = useMountApp(
    {
      url: process.env.REACT_APP_LIVE_CHAT_V2_APP_DEV_PATH,
      scope: 'livechat_v2',
      envKey: apps[AppId.LIVE_CHAT].runtimeEnvKey,
      entryPath: './LiveChatScreenRecorder'
    },
    appProps
  )

  if (isError || !isLoaded || !user) return null

  return <div ref={ref} />
})
